import React, { useState } from "react";
import { ReactComponent as GivingsIcon } from "../../../assets/img/icons/new_givings_history.svg";
import { ReactComponent as PrayerRequestsIcon } from "../../../assets/img/icons/prayer_requests.svg";
import { ReactComponent as VideoIcon } from "../../../assets/img/icons/video_settings.svg";
import { ReactComponent as CommentsIcon } from "../../../assets/img/icons/new_comments.svg";
import { ReactComponent as PostsIcon } from "../../../assets/img/icons/new_posts.svg";
import { ReactComponent as LogoutIcon } from "../../../assets/img/icons/logout.svg";
import { NavLink } from "react-router-dom";
import { ReactComponent as UserIcon } from "../../../assets/img/icons/men.svg";
import { ReactComponent as DashboardIcon } from "../../../assets/img/icons/dashboard.svg";
import { ReactComponent as MembersIcon } from "../../../assets/img/icons/members.svg";
import { ReactComponent as ReportsIcon } from "../../../assets/img/icons/reports.svg";
import { ReactComponent as EventsIcon } from "../../../assets/img/icons/events.svg";
import { ReactComponent as PlansIcon } from "../../../assets/img/icons/plans.svg";
import { ReactComponent as SchedulingIcon } from "../../../assets/img/icons/scheduling.svg";
import { ReactComponent as SettingsIcon } from "../../../assets/img/icons/settings.svg";
import { Collapse } from "reactstrap";

const MobileNav = ({ logoutClick }) => {
	const [isOpen, setIsOpen] = useState(false);

	const toggle = () => setIsOpen(!isOpen);

	return (
		<>
			<div className="filter_pane_bg d-flex justify-content-between align-items-center">
				<p className="m-0 ml-3">Menu</p>
				<button
					className="btn_theme_transparent"
					type="button"
					onClick={toggle}>
					<img
						style={{
							transform: `rotate(${isOpen ? "180" : "0"}deg)`,
						}}
						src="https://cdn1.iconfinder.com/data/icons/cc_mono_icon_set/blacks/16x16/br_down.png"
						className="mx-3"
					/>
				</button>
			</div>
			<Collapse isOpen={isOpen}>
				<ul className="dashboard__nav / flex-md-column">
					<li className="nav-item">
						<NavLink to={`/dashboard/charts/`} className="nav-link">
							<span className="nav-icon nav-icon_stroke">
								<DashboardIcon />
							</span>
							<span>Dashboard</span>
						</NavLink>
					</li>

					<li className="nav-item">
						<NavLink
							to={`/dashboard/account-settings`}
							className="nav-link">
							<span className="nav-icon  nav-icon_sm">
								<UserIcon />
							</span>
							<span>Account Settings</span>
						</NavLink>
					</li>

					<li className="nav-item">
						<NavLink
							to={`/dashboard/givings/`}
							className="nav-link">
							<span className="nav-icon nav-icon_stroke">
								<GivingsIcon />
							</span>
							<span>Givings History</span>
						</NavLink>
					</li>

					<li className="nav-item">
						<NavLink
							to={`/dashboard/prayer-requests`}
							className="nav-link">
							<span className="nav-icon  nav-icon_sm nav-icon_stroke">
								<PrayerRequestsIcon />
							</span>
							<span>Prayer requests</span>
						</NavLink>
					</li>

					<li className="nav-item">
						<NavLink
							to={`/dashboard/video-settings`}
							className="nav-link">
							<span className="nav-icon  nav-icon_sm nav-icon_stroke">
								<VideoIcon />
							</span>
							<span>Video Settings</span>
						</NavLink>
					</li>

					<li className="nav-item">
						<NavLink
							to={`/dashboard/comments`}
							className="nav-link">
							<span className="nav-icon  nav-icon_stroke  nav-icon_sm">
								<CommentsIcon />
							</span>
							<span>Comments</span>
						</NavLink>
					</li>

					<li className="nav-item">
						<NavLink to={`/dashboard/posts`} className="nav-link">
							<span className="nav-icon  nav-icon_stroke  nav-icon_sm">
								<PostsIcon />
							</span>
							<span>Posts</span>
						</NavLink>
					</li>

					<li className="nav-item">
						<NavLink to={`/dashboard/members`} className="nav-link">
							<span className="nav-icon  nav-icon_stroke  nav-icon_sm">
								<MembersIcon />
							</span>
							<span>Members</span>
						</NavLink>
					</li>

					<li className="nav-item">
						<NavLink to={`/dashboard/reports`} className="nav-link">
							<span className="nav-icon  nav-icon_stroke  nav-icon_sm">
								<ReportsIcon />
							</span>
							<span>Reports</span>
						</NavLink>
					</li>
					<li className="nav-item">
						<NavLink to={`/dashboard/events`} className="nav-link">
							<span className="nav-icon  nav-icon_stroke  nav-icon_sm">
								<EventsIcon />
							</span>
							<span>Events</span>
						</NavLink>
					</li>
					<li className="nav-item">
						<NavLink
							to={`/dashboard/event-plans`}
							className="nav-link"
							isActive={(match, location) => {
								if (
									location.pathname ===
									"/dashboard/events-master-calendar"
								) {
									return true;
								}

								return Boolean(match);
							}}>
							<span className="nav-icon  nav-icon_stroke  nav-icon_sm">
								<PlansIcon />
							</span>
							<span>Plans</span>
						</NavLink>
					</li>
					<li className="nav-item">
						<NavLink
							to={`/dashboard/payment-settings`}
							className="nav-link">
							<span className="nav-icon  nav-icon_stroke  nav-icon_sm">
								<SettingsIcon />
							</span>
							<span>Payment Settings</span>
						</NavLink>
					</li>
					{/* <li className="nav-item">
					<NavLink
						to={`/dashboard/volunteer-scheduling`}
						className="nav-link">
						<span className="nav-icon  nav-icon_stroke  nav-icon_sm">
							<SchedulingIcon />
						</span>
						<span>Scheduling</span>
					</NavLink>
				</li> */}
				</ul>
			</Collapse>
			<div className="dashboard__logout_mobile / row">
				<a onClick={logoutClick}>
					<span>
						<LogoutIcon />
					</span>

					<span>Log out</span>
				</a>
			</div>
		</>
	);
};

export default MobileNav;
